/** * * Asynchronously loads the component for
Report Issue
* */ import { lazyLoad } from "utils/loadable";
export const ReportIssue = lazyLoad(
  () => import("./index"),
  (module) => module.ReportIssue
);